import React from 'react';
import { FormSection } from '../../common/FormSection';
import { FormCheckboxGroup } from '../../common/FormCheckboxGroup';
import { BehaviourSupportPlanData } from 'src/models/form-types';

interface LevelOfAdjustmentSectionProps {
  formData: BehaviourSupportPlanData;
  onCheckboxChange: (name: string, checked: boolean, category: keyof BehaviourSupportPlanData) => void;
  className?: string;
}

// Define the level of adjustment options
const levelOfAdjustmentOptions = [
  {
    id: 'adjustment-qdtp',
    name: 'Quality Differentiated Teaching Practice (QDTP)',
    label: 'Quality Differentiated Teaching Practice (QDTP)',
  },
  {
    id: 'adjustment-supplementary',
    name: 'Supplementary',
    label: 'Supplementary',
  },
  {
    id: 'adjustment-substantial',
    name: 'Substantial',
    label: 'Substantial',
  },
  {
    id: 'adjustment-extensive',
    name: 'Extensive',
    label: 'Extensive',
  },
];

export const LevelOfAdjustmentSection: React.FC<LevelOfAdjustmentSectionProps> = ({ 
  formData, 
  onCheckboxChange, 
  className 
}) => {
  const handleCheckboxChange = (name: string, checked: boolean) => {
    // Enforce single selection (radio-like behaviour)
    if (checked) {
      // Uncheck all others first
      if (Array.isArray(formData.levelOfAdjustment)) {
        formData.levelOfAdjustment.forEach(option => {
          if (option !== name) {
            onCheckboxChange(option, false, 'levelOfAdjustment');
          }
        });
      }
      onCheckboxChange(name, true, 'levelOfAdjustment');
    } else {
      onCheckboxChange(name, false, 'levelOfAdjustment');
    }
  };

  return (
    <FormSection title="Level of Adjustment *" className={className}>
      <FormCheckboxGroup
        options={levelOfAdjustmentOptions}
        selectedValues={formData.levelOfAdjustment}
        onChange={handleCheckboxChange}
        columns={2}
      />
    </FormSection>
  );
};
